import React from 'react';
import { TilbudsOverblik } from './components/TilbudsOverblik';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <TilbudsOverblik data-id="element-1" />
    </div>;
}